'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useScrollMasks } from '@/hooks/useScrollMasks';
import { cn } from '@/lib/styles';
import styles from './Scrollable.module.css';
export function Scrollable(t0) {
  const $ = _c(21);
  const {
    className,
    scrollableClassName,
    children
  } = t0;
  const {
    scrollableRef,
    masks
  } = useScrollMasks();
  let t1;
  if ($[0] !== className) {
    t1 = cn(className, styles.scrollableWrapper);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== scrollableClassName) {
    t2 = cn(scrollableClassName, styles.scrollable);
    $[2] = scrollableClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== scrollableRef || $[6] !== t2) {
    t3 = <div ref={scrollableRef} className={t2}>{children}</div>;
    $[4] = children;
    $[5] = scrollableRef;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = masks.top && styles.visible;
  let t5;
  if ($[8] !== t4) {
    t5 = cn(styles.scrollableMaskStart, t4);
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = masks.bottom && styles.visible;
  let t8;
  if ($[12] !== t7) {
    t8 = cn(styles.scrollableMaskEnd, t7);
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t6 || $[19] !== t9) {
    t10 = <div className={t1}>{t3}{t6}{t9}</div>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}